import React from 'react'
// import { CreateSupportAnnounce4Component } from '../../components/Officer/CreateSupportAnnounce4Component'
import { CreateSupportAnnounce10EstimateComponent } from '../../components/Officer/CreateSupportAnnounce10EstimateComponent';
import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { Footer } from "../../components/share/Footer";
export const CreateSupportAnnounce10EstimateContainer = () => {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <CreateSupportAnnounce10EstimateComponent />
            <Footer />
        </div>
    )
}
